// extracted by mini-css-extract-plugin
export default {"btn_primary":"Button_btn_primary__g8Vqr","btn_secondary":"Button_btn_secondary__pJVcF","no_radius":"Button_no_radius__xFAgi"};